export function parseMemoryGridSize(gridSize) {
  const s = (gridSize || '3x4').toString();
  const [c, r] = s.split('x').map(Number);
  const cols = c && !Number.isNaN(c) ? c : 3;
  const rows = r && !Number.isNaN(r) ? r : 4;
  return { cols, rows, total: cols * rows };
}

export function parseSlidingGridSize(gridSize) {
  const s = (gridSize || '3x3').toString();
  const n = parseInt(s.split('x')[0], 10);
  return Math.min(5, Math.max(3, Number.isNaN(n) ? 3 : n));
}

export function parseCatchStarConfig(config) {
  const c = config || {};
  return {
    lives: Math.max(1, parseInt(c.lives, 10) || 3),
    timeLimit: Math.max(10, parseFloat(c.time_limit) || 60),
    spawnInterval: Math.max(0.2, parseFloat(c.spawn_interval) || 0.75),
    spawnIntervalRange: Math.max(0, parseFloat(c.spawn_interval_range) || 0.4),
  };
}

export function parseBubbleConfig(config) {
  const c = config || {};
  return {
    gridCols: Math.min(10, Math.max(4, parseInt(c.grid_cols, 10) || 6)),
    colorsCount: Math.min(8, Math.max(2, parseInt(c.colors_count, 10) || 4)),
    fallInterval: Math.max(1, parseFloat(c.fall_interval) || 5),
    initialRows: Math.max(0, parseInt(c.initial_rows, 10) || 3),
    minMatch: Math.max(2, parseInt(c.min_match, 10) || 3),
    specialChance: Math.min(1, Math.max(0, parseFloat(c.special_chance) || 0.07)),
  };
}

export function parseBlockStackConfig(config) {
  const c = config || {};
  return {
    gridCols: Math.min(12, Math.max(6, parseInt(c.grid_cols, 10) || 10)),
    gridRows: Math.min(24, Math.max(14, parseInt(c.grid_rows, 10) || 18)),
    initialDropInterval: Math.min(2.5, Math.max(0.3, parseFloat(c.initial_drop_interval) || 1.0)),
    linesPerSpeedUp: Math.min(10, Math.max(1, parseInt(c.lines_per_speed_up, 10) || 3)),
    speedMultiplier: Math.min(0.98, Math.max(0.7, parseFloat(c.speed_multiplier) || 0.92)),
    minDropInterval: Math.min(0.5, Math.max(0.08, parseFloat(c.min_drop_interval) || 0.15)),
  };
}
